module.exports = __webpack_public_path__ + "static/media/2026_The-Game-NRL_In-Article-Banner_TIP.f67f0852.webp";